import { render, staticRenderFns } from "./WidgetsControls.vue?vue&type=template&id=2ada2729&scoped=true"
import script from "./WidgetsControls.vue?vue&type=script&lang=ts"
export * from "./WidgetsControls.vue?vue&type=script&lang=ts"
import style0 from "./WidgetsControls.vue?vue&type=style&index=0&id=2ada2729&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ada2729",
  null
  
)

export default component.exports